import { configureStore } from '@reduxjs/toolkit';

import authReducer from '~/redux/reducers/auth';
import cartReducer from '~/redux/reducers/cart';
import inventoryReducer from '~/redux/reducers/inventory';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    cart: cartReducer,
    inventory: inventoryReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
